import { ResourceType } from "@prisma/postgresClient";

export default ResourceType;

export const { ASSET, CONTENT, ...EmployeeResourceType } = ResourceType;
